<template>
  <div class="header">
    <div
      class="jumbotron jumbotron-fluid"
      :class="jumbotronClasses"
    >
      <div
        v-if="header !== 'empty' && !header.video && !contrast"
        class="hero"
        :id="'hero_img_'+header.image"
      ></div>
      <div
        v-if="header!== 'empty' && !header.video && !contrast"
        class="hero blurred"
        :id="'hero_img_'+header.image"
      ></div>
      <fcwpVideo
        v-if="header && header.video && !contrast"
        :video="header.video"
        :poster="header.poster"
        :key="header.id"
        ref="video-outer"
      />
      <nav id="navbar" class="navbar navbar-expand-xl">
        <fcwpLogo :url="meta.url" :image="meta.logo" :title="meta.title"></fcwpLogo>
        <fcwpToggler />
        <fcwpMenu
          menu_class="navbar-collapse collapse multi-collapse order-3 order-xl-1 menu"
          id="menu_left"
          :items="meta.menu.menu_left"
        />
        <fcwpMenu
          menu_class="navbar-collapse collapse multi-collapse order-4 order-xl-3 menu"
          id="menu_right"
          :items="meta.menu.menu_right"
        />
      </nav>
      <fcwpTurbo v-if="header !== 'empty'&& !contrast" :data="header"></fcwpTurbo>
      <fcwpLangs :langs="langs" />
      <div class="specials-social">
        <fcwpSpecials :switchers="switchers" />
        <fcwpSocial :items="meta.social" />
      </div>
    </div>
  </div>
</template>


<script>
import classNames from "classnames";

import fcwpLogo from "./header/fcwpLogo.vue";
import fcwpMenu from "./header/fcwpMenu.vue";
import fcwpToggler from "./header/fcwpToggler.vue";
import fcwpSpecials from "./header/fcwpSpecials.vue";
import fcwpTurbo from "./header/fcwpTurbo.vue";
import fcwpSocial from "./header/fcwpSocial.vue";
import fcwpLangs from "./header/fcwpLangs.vue";
import fcwpVideo from "./header/fcwpVideo.vue";
import fcwpTurboVue from './header/fcwpTurbo.vue';

export default {
  name: "fcwpHeader",
  props: ["meta", "header", "contrast", "langs", "switchers"],
  data() {
    return {
      jumbotronClasses: '',
    };
  },
  components: {
    fcwpLogo,
    fcwpMenu,
    fcwpToggler,
    fcwpSpecials,
    fcwpTurbo,
    fcwpSocial,
    fcwpLangs,
    fcwpVideo
  },
  methods: {
    changeClass() {
      document.getElementById("menu_left").classList.remove("show");
      document.getElementById("menu_right").classList.remove("show");
      if (document.getElementById("turbo") !== null)
        document.getElementById("turbo").classList.add("show");
    },
    setJumbotronClasses() {
      this.jumbotronClasses = classNames({
        "regular": this.header === "empty" || this.contrast,
        "jumbotron-video": this.header.video && !this.contrast,
        "jumbotron-image": this.header.image && !this.header.video && !this.contrast,
      });
    }
  },
  mounted() {
    this.$root.$on("submenu_clicked", this.changeClass);
    this.setJumbotronClasses();
  },
  updated() {
    this.setJumbotronClasses();
  }
};
</script>

<style lang="scss">
.jumbotron {
  //margin: 1.17vw 1.17vw 0 1.17vw !important;
  //border-top: 1.17vw solid rgb(235, 174, 174);
  padding: 0 !important;
  position: relative;
  background: rgb($tertiary-color) !important;
}

.jumbotron-image {
  margin: 1.17vw 1.17vw 0 1.17vw !important;
  background: none !important;
  background-size: cover;
  min-height: calc(100vh - 1.17vw);
  margin: 1.17vw 0 0 0 !important;
}

.regular {
  margin: 1.17vw 1.17vw 0 1.17vw !important;
}

.hero {
  position: absolute;
  width: 100%;
  height: 100%;
  background: no-repeat top center;
  background-color: rgb($primary-color) !important;
  background-blend-mode: luminosity;
  background-size: cover;
}

#hero_img_undefined {
  background-color: unset !important;
}

.blurred {
  filter: blur(5px);
  -webkit-filter: blur(5px);
  z-index: -5;
  -webkit-mask-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.7) 10%,
    rgba(0, 0, 0, 0) 50%
  );
  mask-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 10%,
    rgba(0, 0, 0, 0) 50%
  );
}

.hero {
  min-height: calc(
    100vh - 1.17vw
  ); // daje elastyczność calego boxu (istotne przy mobile view przy rozwijaniu listy)
  // margin: 1.17vw 0 0 0 !important;
}

.navbar {
  padding: 0 !important;
}

.specials-social {
  position: absolute;
  right: -1.17vw;
  top: 15vh;
  width: 50px;
}

.jumbotron-image,
.jumbotron-video {
  .specials-social {
    right: 0;
  }
}

@media (max-width: 700px) {
  .specials-social {
    width: 31px;

    .specials .accessibility-btn {
      width: 31px;
      height: 40px;
      font-size: 15pt;
    }
  }
}
</style>